<template>
  <div class="px-[10px]">
    <div class="flex items-center justify-between gap-3 px-[10px] py-[10px]">
      <div class="min-w-0">
        <div class="text-[14px] font-medium leading-[18px] text-gray-800">
          {{ title }}
        </div>
        <Skeleton v-if="loading" class="mt-1 h-[13px] w-[60px]" />
        <div v-else class="text-[14px] leading-[18px] text-gray-500">
          {{ formattedTotal }} {{ total === 1 ? 'result' : 'results' }}
        </div>
      </div>
      <Button
        v-if="!loading && total"
        variant="primary"
        size="md"
        @click="$emit('view-all')"
      >
        View all
      </Button>
    </div>

    <template v-if="loading">
      <Table :sticky-header="false">
        <Table.Head>
          <Table.Header primary>
            <Skeleton class="h-[11px] w-[44px]" />
          </Table.Header>
          <Table.Header class="w-[250px]">
            <Skeleton class="h-[11px] w-[60px]" />
          </Table.Header>
        </Table.Head>

        <Table.Row v-for="n in 3" :key="n">
          <template #media>
            <div class="size-6">
              <Skeleton class="size-6 rounded" />
            </div>
          </template>
          <Table.Cell primary>
            <Skeleton class="h-[13px] w-[120px]" />
          </Table.Cell>
          <Table.Cell class="w-[250px]">
            <Skeleton class="h-[13px] w-[140px]" />
          </Table.Cell>
        </Table.Row>
      </Table>
    </template>

    <div
      v-else-if="!total"
      class="border-t border-[#efefef] px-[10px] py-[11px] text-[14px] leading-[18px] text-gray-500"
    >
      {{ emptyLabel }}
    </div>

    <template v-else>
      <Table :sticky-header="false">
        <Table.Head>
          <Table.Header primary>Name</Table.Header>
          <Table.Header class="w-[250px]">{{ col2Label }}</Table.Header>
        </Table.Head>
        <slot />
      </Table>
    </template>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { Button, Skeleton, Table } from '@dacr/library'
import { formatNumber } from '@/shared/utils/number'

const props = defineProps<{
  title: string
  total?: number
  loading: boolean
  emptyLabel: string
  col2Label: string
}>()

defineEmits<{ 'view-all': [] }>()

const formattedTotal = computed(() => formatNumber(props.total ?? 0))
</script>
